<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>   
    <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
    <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->
 

      <div class="page-wrapper">

        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                
                 <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6 class="card-title mb-0 float-start" style="padding-left:25px"> {{ $t("client_login") }} </h6>
                  <button
                    class="btn btn-light float-end"
                    type="button"
                    data-bs-toggle="collapse" 
                    data-bs-target="#collapseExample" 
                    aria-expanded="false" 
                    aria-controls="collapseExample"
                  >
                    <i class="link-icon" data-feather="info"></i>
                    Audit Info
                  </button>

                  <div class="row mb-3 collapse" id="collapseExample" style="padding-left:20px">
                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0 ">Created By:</label>
                      <p class="text-muted">{{this.forms.created_by}}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Created At:</label>
                      <p class="text-muted">{{this.forms.created_at}}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Updated By:</label>
                      <p class="text-muted">{{this.forms.updated_by}}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Updated At:</label>
                      <p class="text-muted">{{this.forms.updated_at}}</p>
                    </div>

                    
                    
                  </div>

                </div>
                <div class="card-body">
              

                    <form
                        class="forms-sample"
                        @submit.prevent="submitData"
                        method="POST"
                    >
                    
 
 
 
                    <div class="row mb-2">


                        <div class="col-lg-12">

                            <label for="defaultconfig" class="col-form-label required">{{  $t('ppjk_id')  }}</label>

                            <v-select :options="fetchPpjk" v-model="ppjk" :id="this.$dynamicId()" label="nama" return-object disabled>  </v-select>

                            <div v-if="errors.ppjk_id">
                                <div v-for="error in errors.ppjk_id" :key="error" class="alert alert-primary" role="alert">
                                    <i data-feather="alert-circle"></i> {{ error }}
                                </div>
                            </div>

                        </div>


                        <div class="col-lg-4">

                            <label for="defaultconfig" class="col-form-label required">{{  $t('userName')  }}</label>

                            <input type="text" readonly class="form-control" :id="this.$dynamicId()" :placeholder="$t('userName')" v-model="forms.username" />

                            <div v-if="errors.username">
                                <div v-for="error in errors.username" :key="error" class="alert alert-primary" role="alert">
                                    <i data-feather="alert-circle"></i> {{ error }}
                                </div>
                            </div>

                        </div>

                        <div class="col-lg-4">

                            <label for="defaultconfig" class="col-form-label required">{{  $t('password')  }}</label>

                            <input type="text" readonly class="form-control" :id="this.$dynamicId()" :placeholder="$t('password')" v-model="forms.password" />

                            <div v-if="errors.password">
                                <div v-for="error in errors.password" :key="error" class="alert alert-primary" role="alert">
                                    <i data-feather="alert-circle"></i> {{ error }}
                                </div>
                            </div>

                        </div>


                        <div class="col-lg-4">

                            <label for="defaultconfig" class="col-form-label required">{{  $t('endpoint')  }}</label>

                            <input type="text" readonly class="form-control" :id="this.$dynamicId()" :placeholder="$t('endpoint')" v-model="forms.endpoint" />

                            <div v-if="errors.endpoint">
                                <div v-for="error in errors.endpoint" :key="error" class="alert alert-primary" role="alert">
                                    <i data-feather="alert-circle"></i> {{ error }}
                                </div>
                            </div>

                        </div>

                       



    

                    </div>

 

                    







                   
                    <div class="card-footer">
                      
                      <button
                        class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>

                      <a
                        v-if="permision_role.method_update"
                        class="
                          btn btn-primary
                          me-2
                          text-white
                          fw-bolder
                          btn-icon-text
                          float-end
                        "
                        @click="editData()"
                      >
                        <i class="link-icon" data-feather="edit"></i>
                        {{ $t("editMess") }}
                      </a>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>
  
  
<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
 

export default {
    name: "CeisaClientLoginIndex",
    props: {},
    components: {

        "navbar-component": navbarComponent,
        "footer-component": footerComponent,

    },
    data() {
        const startDate = new Date();// new Date();
        const endDate = new Date();

        return {
        dateFilter: {
            startDate,
            endDate,
        },
        asnType: [],
        fetchAsnType: [],
        trackingOrderStatus: [],

        expectedShipmentTime1dateFilter: {
            startDate,
            endDate,
        },

        showModalNow: false,

        opens: "center",
        locale: {
            format: "yyyy-mm-dd H:MM:ss",
        },

        localeDetail: {
            format: "yyyy-mm-dd",
        },

        highlighted: {

            dates: [ // Highlight an array of dates
            new Date(),
            ],

        },

        digit: {
            decimal: ',',
            thousands: '.',
            prefix: ' ',
            suffix: '',
            precision: 5,
            masked: false
        },
        fetchStockCondition: [],
        detailAsn: [],
        orderType: '',
        fetchOrderType: [],
        shelfLifeUnit: {},
        shelfLifeType: {},
        permision_role: [],
        isLoading: false,
        maxToasts: 100,
        position: "up right",
        closeBtn: true,
        errors: [],
        userData: "",
        userRole: "",
        companyCode: "",
        fetchStatus: ['ACTIVE', 'DEACTIVE'],
        fetchmultiWhFlag: ['Y', 'N'],
        fetchCustomer: [],
        fetchFulfillment: [],
        customer: "",
        fetchPpjk:[],
        fulfillment: "",
        fetchShelfLifeType: [],
        fetchShelfLifeUnit: [],
        fetchSku: [],
        activeFlag: false,
        shelfLifeFlag: false,
        kitFlag: false,
        freePickGift: false,
        isLoadingStatus: false,
        forms: {client_id:"", username:"", password:"", endpoint:"",  created_by:"", updated_by:"" , created_at:"", updated_at:""},
        ppjk: {ppjk_id:"", nama:"", alamat:"", no_npwp:"",  np_ppjk:"", updated_by:"" , created_at:"", updated_at:""},
        };
    },
    watch: {},
    methods: {




        backForm() {
            window.location.href = "/exim/ceisa/client-login";
        },

        asyncPpjk(ev) {
            this.fetchPpjk = [];
            const baseURI = this.$settings.endPointFluxOms + "v2/ppjk/index?nama=" + ev;

            return this.$http
                .get(
                baseURI, { timeout: 10000 }
                )
                .then((response) => {
                    this.fetchPpjk = response.data.datas.data;
                }).catch(error => {

                if (error.code == "ECONNABORTED") {
                    this.error("Please Check Your Internet Connection");
                }

                });
        },

        editData() {

            var params = this.$onRandom(1);
            window.location.href = "/exim/ceisa/client-login/edit/" + params;

        },

        loadData() {

            var params  = this.$onBehind(this.$route.params.id);
            var id      = params[0];
            this.isLoading = true;
            const baseURI  = this.$settings.endPointCeisa + "v1/client/detail/" + id;

            return this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

                this.isLoading = false;
                this.forms      = response.data.datas;
                this.ppjk       = response.data.datas.ppjk_detail;
 

            }).catch(error => {

                this.isLoading = false;

                if (error.code == "ECONNABORTED") {
                 this.error(this.$t("check_internet_connection_txt"));
                } else {

                    if (error.response) {
                        if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                        } else if (error.response.status === 401) {
                        this.logout();
                        } else if (error.response.status === 403) {
                        this.$router.push("/authorized-error");
                        } else if (error.response.status === 500) {
                        this.$router.push('/server-error');
                        } else {
                        this.$router.push('/page-not-found');
                        }
                    }

                }

            });

        },

        fetchIt() {
            const userDatas = this.$getUserInfo();
            this.userData = userDatas.sub;
            this.userRole = userDatas.sub.role;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function (permision) {
                if (permision.permission.controller == 'CeisaClientController') {
                    rolePermision = permision;
                }
            });

            if (!rolePermision.method_read) {
                this.$router.push("/authorized-error");
            }

            this.permision_role = rolePermision;

        },

        logout() {

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

                console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },


        cek_message(status,msg){
            if(status=='200'){
                this.success(msg);
            }
        },

    },
    events: {},
    created: function () { },
    mounted() {

        this.fetchIt();
        this.loadData();
        this.cek_message(this.$route.query.status,this.$route.query.msg);


    },
};
</script>
<style scoped>.required:after {
  content: " *";
  color: red;
}</style>